import {
  RECEIVED_PROFILE_INFO, ERROR_ON_GETTING_PROFILE, START_FETCHING_PROFILE,
  CHANGE_TAB_PAGE, RESET_PROFILE, SHOW_ACCOUNT_SETTING
} from "../actions/types";

const initState = {
  loading: true,
  profile: {},
  error: null,
  selectedPage: 0
}

const userProfileReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case START_FETCHING_PROFILE:
      return { ...state, loading: true}
    case RECEIVED_PROFILE_INFO:
      return { ...state, profile: payload.profile, loading: false, error: null };
    case ERROR_ON_GETTING_PROFILE:
      return { ...state, error: payload.error, loading: false };
    case CHANGE_TAB_PAGE:
      return { ...state, selectedPage: payload.pageNum }
    case RESET_PROFILE:
      return { ...state, ...initState }
    case SHOW_ACCOUNT_SETTING:
      return { ...state, selectedPage: 3}
    default:
      return state;
  }
}

export default userProfileReducer;


// WEBPACK FOOTER //
// ./src/reducers/user-profile-reducer.js